import { v4 as uuid } from 'uuid';
import AccommodationSection from './component/AccommodationSection';
import CarHireSection from './component/CarHireSection';
import CruisesSection from './component/CruisesSection';
import ExtraSection from './component/ExtraSection';
import FlightSection from './component/FlightSection';
import PackageSection from './component/PackagesSection';
import TourSection from './component/TourSection';
import TransferSection from './component/TransferSection';
import DayIcon from './component/common/DayIcon';

export default function DaySummary(props) {
  const { sectionTitle, itinerary, date } = props;
  const componentsKeys = Object.keys(itinerary);

  // reorder the itinerary based on specific component order unless it's the last day
  const isLastDay = componentsKeys[componentsKeys.length - 1] === date;
  const itineraryComponents =
    itinerary[date] &&
    itinerary[date].sort((a, b) => {
      const aComponentName = Object.keys(a)[0].split('-')[0];
      const bComponentName = Object.keys(b)[0].split('-')[0];

      const componentOrder = [
        'Transfer',
        'Car Hire',
        'Accommodation',
        'Cruises',
        'Package',
        'Extra',
        'Tour',
      ];

      if (isLastDay) {
        componentOrder.push('Flight');
      } else {
        componentOrder.unshift('Flight');
      }

      return (
        componentOrder.indexOf(aComponentName) -
        componentOrder.indexOf(bComponentName)
      );
    });

  const renderComponent = (componentData, isLastComponent) => {
    const componentFullName = Object.keys(componentData)[0];
    const componentName = componentFullName.split('-')[0];
    const componentProps = {
      componentFullName,
      componentName,
      componentData,
      isLastComponent,
    };

    const componentToRender = {
      Flight: <FlightSection componentProps={componentProps} />,
      Transfer: <TransferSection componentProps={componentProps} />,
      'Car Hire': <CarHireSection componentProps={componentProps} />,
      Accommodation: <AccommodationSection componentProps={componentProps} />,
      Cruise: <CruisesSection componentProps={componentProps} />,
      Package: <PackageSection componentProps={componentProps} />,
      Extra: <ExtraSection componentProps={componentProps} />,
      Tour: <TourSection componentProps={componentProps} />,
    };

    return componentToRender[componentName] || null;
  };

  const ignoreDay =
    sectionTitle.includes('Invalid date') || sectionTitle.includes('NaN');

  return (
    <div className={ignoreDay ? 'hidden' : ''}>
      {sectionTitle && (
        <DayIcon
          sectionTitle={sectionTitle}
          classNames="flex items-center mt-10"
        />
      )}
      {itinerary &&
        itineraryComponents &&
        itineraryComponents.map((component, idx) => (
          <div key={uuid()}>
            {renderComponent(
              component,
              itineraryComponents.length - 1 === idx &&
                Object.keys(itinerary).length ===
                  componentsKeys.indexOf(date) + 1,
            )}
          </div>
        ))}
    </div>
  );
}
